import { useEffect, useState } from 'react'
import { Ridge } from './Ridge'
import { Summit } from './Summit'
import { Wind } from './Wind'
import './brand-kit.css'

/** Follows <html data-theme>, so the scene swaps with the theme toggle. */
export function useDarkTheme(): boolean {
  const read = () => document.documentElement.getAttribute('data-theme') === 'dark'
  const [dark, setDark] = useState(read)
  useEffect(() => {
    const obs = new MutationObserver(() => setDark(read()))
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] })
    return () => obs.disconnect()
  }, [])
  return dark
}

const SUN = {
  dark: { cx: 800, cy: 342, r: 88, glow: 0 },
  light: { cx: 800, cy: 356, r: 84, glow: 0 },
}

/**
 * The sign-in ground, as on app.trodo.ai: trodo.ai's range along the bottom (light: pale ridges and a low sun;
 * dark: the night range with snow) and wind specks drifting over it. Fills its positioned parent.
 */
export function BrandGround() {
  const dark = useDarkTheme()
  const sun = dark ? SUN.dark : SUN.light
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 z-0 select-none overflow-hidden" style={{ background: dark ? '#141312' : '#f4f4f2' }}>
      <div
        className="absolute"
        style={{
          left: '50%',
          bottom: dark ? '-6%' : '-2%',
          width: 'min(60vw, 820px)',
          aspectRatio: '1 / 1',
          transform: 'translateX(-50%)',
          background: dark
            ? 'radial-gradient(circle, rgb(var(--trodo-primary-rgb) / .30) 0%, rgb(var(--trodo-primary-rgb) / .13) 36%, transparent 66%)'
            : 'radial-gradient(circle, rgb(var(--trodo-primary-rgb) / .30) 0%, rgb(var(--trodo-primary-rgb) / .14) 36%, transparent 68%)',
        }}
      />
      <div
        className={`${dark ? 'console-summit' : 'td-ridge'} absolute bottom-0`}
        // at least 800px wide (so it is never too low on phones) and centred, so the sun stays in the middle
        style={{ left: '50%', transform: 'translateX(-50%)', width: 'max(100%, 800px)', aspectRatio: dark ? '1600 / 600' : '1600 / 560', overflow: 'visible' }}
      >
        {dark ? <Summit sun={sun} /> : <Ridge sun={sun} className={undefined} />}
        <Wind />
        {dark && <style>{'.console-summit .sm { position: absolute; inset: 0; height: 100%; }'}</style>}
      </div>
    </div>
  )
}
